import { ScheduleType } from "../enums/product-capture.enums";
import { SCHEDULE_TYPE_ENUM } from "../enums/schedule-type.enum";

export const SCHEDULE_TYPE = [
  { id: 'PAYMENT_PRIMARY', displayValue: 'Payment primary' },
  { id: 'OBS_PRIMARY', displayValue: 'Obs primary' },
  { id: 'INDEPENDENT', displayValue: 'Independent' },
  { id: 'PAYMENT_ONLY', displayValue: 'Payment only' },
  { id: 'OBS_ONLY', displayValue: 'Obs only' },
  { id: 'ACCRUAL_PRIMARY', displayValue: 'Accrual Primary' },
];

export const SCHEDULE_TYPE_CLN = [
  { id: 'ACCRUAL_PRIMARY', displayValue: 'Accrual Primary' },
];

export const createScheduleTypeOptionsByType = (scheduleType: ScheduleType, hasUnderlyingAssets: boolean) => {
  if (scheduleType !== ScheduleType.COUPON && scheduleType !== ScheduleType.CALLABILITY) {
    return [];
  }

  const optionByType = { 
    id: SCHEDULE_TYPE_ENUM.ACCRUAL_PRIMARY, 
    displayValue: 'Accrual primary' 
  };

  return [
    { id: SCHEDULE_TYPE_ENUM.OBS_PRIMARY, displayValue: 'Obs primary' },
    { id: SCHEDULE_TYPE_ENUM.PAYMENT_PRIMARY, displayValue: 'Payment primary' },
    ...(!hasUnderlyingAssets && [optionByType] || []),
    { id: SCHEDULE_TYPE_ENUM.PAYMENT_ONLY, displayValue: 'Payment only' },
    { id: SCHEDULE_TYPE_ENUM.INDEPENDENT, displayValue: 'Created Independently' },
  ]
}

export const SHOULD_EMPTY_LAG_FIELDS = [
  SCHEDULE_TYPE_ENUM.INDEPENDENT,
  SCHEDULE_TYPE_ENUM.PAYMENT_ONLY,
  SCHEDULE_TYPE_ENUM.OBS_ONLY,
]